module.exports = __webpack_public_path__ + "media/images/icons/outlined/rocket-4b099900792f5a5403404bff3a216123.svg";